import React from "react";
import { AHText } from "arkh";

export function OrgSpaceCreateTitles(props: {
  title: React.ReactNode;
  subTitle: React.ReactNode;
}) {
  return (
    <>
      <AHText
        type="title-big"
        spaceTop="xlarge"
        textAlign="center"
        spaceBottom="medium"
      >
        {props.title}
      </AHText>
      <AHText spaceBottom="xlarge" textAlign="center">
        {props.subTitle}
      </AHText>
    </>
  );
}
